import React, { Component } from 'react';
import Line from './line';
import './index.css';

class DescSection extends Component {
  _prevBullet = 'first';
  constructor(props) {
    super(props);
    this.state = {
    }

    this.clickHandler = this.clickHandler.bind(this);
    this.changeBullet = this.changeBullet.bind(this);
    this.animateLine = this.animateLine.bind(this);
    this.changeImage = this.changeImage.bind(this);
    this.getLayout = this.getLayout.bind(this);
  }


  changeBullet(target, parent){
    for(var i=0; i<parent.children.length; i++){
      var child = parent.children[i].children[1];
      if(child && child.dataset.tag === target){child.classList.add("desc-slider-ss-bullet-active")} 
      else {child.classList.remove("desc-slider-ss-bullet-active")}
    }
  }

  animateLine(target){
    var path = document.getElementById('svg-path-section-stream-fill');
    var classList = path.classList;
    if(this._prevBullet !==target){while (classList.length > 0) {classList.remove(classList.item(0))}}


    //first

    if(this._prevBullet === 'first' && target === 'second'){
      classList.add("animate-svg-path-streamline-from-first-to-second");
    }

    if(this._prevBullet === 'first' && target === 'third'){
      classList.add("animate-svg-path-streamline-from-first-to-third");
    }


    if(this._prevBullet === 'first' && target === 'fourth'){
      classList.add("animate-svg-path-streamline-from-first-to-fourth");
    }

    if(this._prevBullet === 'first' && target === 'fifth'){
      classList.add("animate-svg-path-streamline-from-first-to-fifth");
    }

    if(this._prevBullet === 'first' && target === 'sixth'){
      classList.add("animate-svg-path-streamline-from-first-to-sixth");
    }


    //second

    if(this._prevBullet === 'second' && target === 'first'){
      classList.add("animate-svg-path-streamline-from-second-to-first");
    }

    if(this._prevBullet === 'second' && target === 'third'){
      classList.add("animate-svg-path-streamline-from-second-to-third");
    }

    if(this._prevBullet === 'second' && target === 'fourth'){
      classList.add("animate-svg-path-streamline-from-second-to-fourth");
    }

    if(this._prevBullet === 'second' && target === 'fifth'){
      classList.add("animate-svg-path-streamline-from-second-to-fifth");
    }

    if(this._prevBullet === 'second' && target === 'sixth'){
      classList.add("animate-svg-path-streamline-from-second-to-sixth");
    }


    //third

    if(this._prevBullet === 'third' && target === 'first'){
      classList.add("animate-svg-path-streamline-from-third-to-first");
    }

    if(this._prevBullet === 'third' && target === 'second'){
      classList.add("animate-svg-path-streamline-from-third-to-second");
    }

    if(this._prevBullet === 'third' && target === 'fourth'){
      classList.add("animate-svg-path-streamline-from-third-to-fourth");
    }

    if(this._prevBullet === 'third' && target === 'fifth'){
      classList.add("animate-svg-path-streamline-from-third-to-fifth");
    }
    if(this._prevBullet === 'third' && target === 'sixth'){
      classList.add("animate-svg-path-streamline-from-third-to-sixth");
    }


    //fourth

    if(this._prevBullet === 'fourth' && target === 'first'){
      classList.add("animate-svg-path-streamline-from-fourth-to-first");
    }
    
    if(this._prevBullet === 'fourth' && target === 'second'){
      classList.add("animate-svg-path-streamline-from-fourth-to-second");
    }
    
    if(this._prevBullet === 'fourth' && target === 'third'){
      classList.add("animate-svg-path-streamline-from-fourth-to-third");
    }

    if(this._prevBullet === 'fourth' && target === 'fifth'){
      classList.add("animate-svg-path-streamline-from-fourth-to-fifth");
    }

    if(this._prevBullet === 'fourth' && target === 'sixth'){
      classList.add("animate-svg-path-streamline-from-fourth-to-sixth");
    }


    //fifth

    if(this._prevBullet === 'fifth' && target === 'first'){
      classList.add("animate-svg-path-streamline-from-fifth-to-first");
    }

    if(this._prevBullet === 'fifth' && target === 'second'){
      classList.add("animate-svg-path-streamline-from-fifth-to-second");
    }

    if(this._prevBullet === 'fifth' && target === 'third'){
      classList.add("animate-svg-path-streamline-from-fifth-to-third");
    }

    if(this._prevBullet === 'fifth' && target === 'fourth'){
      classList.add("animate-svg-path-streamline-from-fifth-to-fourth");
    }

    if(this._prevBullet === 'fifth' && target === 'sixth'){
      classList.add("animate-svg-path-streamline-from-fifth-to-sixth");
    }


    //sixth

    if(this._prevBullet === 'sixth' && target === 'first'){
      classList.add("animate-svg-path-streamline-from-sixth-to-first");
    }

    if(this._prevBullet === 'sixth' && target === 'second'){
      classList.add("animate-svg-path-streamline-from-sixth-to-second");
    }

    if(this._prevBullet === 'sixth' && target === 'third'){
      classList.add("animate-svg-path-streamline-from-sixth-to-third");
    }

    if(this._prevBullet === 'sixth' && target === 'fourth'){
      classList.add("animate-svg-path-streamline-from-sixth-to-fourth");
    }

    if(this._prevBullet === 'sixth' && target === 'fifth'){
      classList.add("animate-svg-path-streamline-from-sixth-to-fifth");
    }

    this._prevBullet = target;
  }

  changeImage(key){
    var path = document.getElementById('desc-slider-ss-img-wc');
    var imgs = path.children[0].children ;
    for(var i=0; i<imgs.length; i++){
      var img = imgs[i];
      if(i === key){ img.classList.add('desc-slider-ss-active-image')}
      else {while (img.classList.length > 0) {img.classList.remove(img.classList.item(0))}}
    }
  }

  clickHandler(e, key) {
    var target = e.target.dataset.tag;
    var parent = e.target.parentElement.parentElement;
    this.changeBullet(target, parent);
    this.animateLine(target);
    this.changeImage(key);
  }

  getLayout(){
    if (window.matchMedia('(max-width: 950px)').matches) { return true } 
    else {return false}
  }

  render() {
    const { lang } = this.props;
    const responsive = this.getLayout();
    if(responsive){
      return (
        <div className='desc-slider-ss-svg-responsive-container'>

          <div>
            <img alt='' src={require('../../../../assets/images/pic-sl1.png')}/>
            <h2>{lang === 'fa' ?'نقشه بازار':'Market Map'}</h2>
            <p>{lang === 'fa' ?'امکان مشاهده "اطلاعات بنیادی" در قالب طرح گرافیکی امکانی است که برای اولین بار در ایران توسط بورس ویو ارائه شده است. این نقشه به شما کمک می کند تا سهامی که معمولا از میدان دید شماخارج هستند را به راحتی پیدا کنید.':'All listed companies trading details since IPO day'}</p>
          </div>

          <div>
            <img alt='' src={require('../../../../assets/images/pic-sl2.png')}/>
            <h2>{lang === 'fa' ?'اطلاعات محاسباتی':'Fundamental Chart'}</h2>
            <p>{lang === 'fa' ?'اطلاعات کلی شامل شاخص های بازار، ده سهم اول و اطلاعیه ها و مجامع مربوط به هرسهم بخشی از اطلاعاتی ست که بورس ویو در اختیار قرار میدهد':'Easily create fundamental charts in seconds to compare stocks, financial items, key stats and more'}</p>
          </div>

          <div>
            <img alt='' src={require('../../../../assets/images/pic-sl3.png')}/>
            <h2>{lang === 'fa' ?'صورت های مالی':'Screener'}</h2>
            <p>{lang === 'fa' ?'دسترسی ساده به صورت های مالی فصلی و سالانه شرکت های بورسی و زیر مجموعه ها. نحوه نمایش این صورت ها امکان مشاهده روند تغییرات فصلی و سالانه اعداد و حاشیه های صورت های مالی را تنها با چند کلیک میسر می سازد':'Meet the stocks that meet your criteria in a second using more than 20 filters'}</p>
          </div>

          <div>
            <img alt='' src={require('../../../../assets/images/pic-sl4.png')}/>
            <h2>{lang === 'fa' ?'نمودارهای بنیادی':'Fundamental Chart'}</h2>
            <p>{lang === 'fa' ?'اطلاعات بنیادی و نسبت های مالی شرکت ها را به راحتی و به زبان نمودار با یکدیگر مقایسه کنید. کلیه اطلاعات صورت های مالی و اقلام محاسباتی بصورت لحطه ای قابل دسترس و استفاده کاربران است':'Easily create fundamental charts in seconds to compare stocks, financial items, key stats and more'}</p>
          </div>

          <div>
            <img alt='' src={require('../../../../assets/images/pic-sl7.png')}/>
            <h2>{lang === 'fa' ?'فیلتر بنیادی سهام':'Fundamental Chart'}</h2>
            <p>{lang === 'fa' ?'فیلتر یا غربالگر سهام، ابزار فوق العاده قدرتمندی است که امکان پیدا کردن سهام متناسب با استراتژی شما را میسر می سازد. فقط کافی است چند دقیقه با اسکرینر بورس ویو کار کنید تا همیشه یک قدم از بازار جلوتر باشید':'Easily create fundamental charts in seconds to compare stocks, financial items, key stats and more'}</p>
          </div>

          <div>
            <img alt='' src={require('../../../../assets/images/pic-sl5.png')}/>
            <h2>{lang === 'fa' ?'نسبت های مالی':'Fundamental Chart'}</h2>
            <p>{lang === 'fa' ?'مهمترین نسبت های مالی بر اساس نوع فعالیت شرکت ها برای هر شرکت محاسبه می شوند. محاسبه این نسبت ها از دقت فوق العاده ای برخوردار است که قبلا هیچوقت در بازار ایران پیاده سازی نشده است':'Easily create fundamental charts in seconds to compare stocks, financial items, key stats and more'}</p>
          </div>

        </div>
      )
    } else {
      return (
        <div className='desc-slider-ss-svg-container'>
          <div className='desc-slider-ss-top-line-wrapper'>
            <svg xmlnsXlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
              <line x1="0" y1='0' x2="100%" y2='0' stroke="rgb(244, 135, 122)" strokeWidth="0.7" className="desc-slider-ss-animate-top-svg-line" />
            </svg>
          </div>
          <div className='desc-slider-ss-svg-header-subheader'>
            <h1>{lang === 'fa' ?'بورس ویو چطور به شما کمک می کند':'How BourseView Can Help You'}</h1>
            <p>{lang === 'fa' ?'بورس ویو با فراهم کردن اطلاعات مالی دقیق و سریع و رابط کاربری ساده جهت تحلیل، مقایسه، گزارشگیری و ذخیره سازی اطلاعات در سطوح سهم، صنعت و بازار، به تصمیم گیری بهینه و صرفه جویی سرمایه گذاران و تحلیلگران کمک میکند':'Bourse View helps optimize and save investors and analysts by providing accurate and fast financial information and a simple interface for analyzing, comparing, reporting and storing information at the level of stock, industry and market.'}</p>
          </div>
          <div id='desc-slider-ss-img-wc'>
            {/* <div>this is image</div> */}
            <div>
              <img alt='' className='desc-slider-ss-active-image' src={require('../../../../assets/images/pic-sl1.png')}/>
              <img alt='' src={require('../../../../assets/images/pic-sl2.png')}/>
              <img alt='' src={require('../../../../assets/images/pic-sl3.png')}/>
              <img alt='' src={require('../../../../assets/images/pic-sl4.png')}/>
              <img alt='' src={require('../../../../assets/images/pic-sl7.png')}/>
              <img alt='' src={require('../../../../assets/images/pic-sl5.png')}/>
            </div>
          </div>
          <div className='desc-slider-ss-text-wc'>
            <ul>
              
              <li>
                <div>
                  <h2>{lang === 'fa' ?'نقشه بازار':'Market Map'}</h2>
                  <p>{lang === 'fa' ?'امکان مشاهده "اطلاعات بنیادی" در قالب طرح گرافیکی امکانی است که برای اولین بار در ایران توسط بورس ویو ارائه شده است. این نقشه به شما کمک می کند تا سهامی که معمولا از میدان دید شماخارج هستند را به راحتی پیدا کنید.':'You can see "Fundamental information" in a graphic template. This map helps you find stocks very easy.'}</p>
                </div>
                <span className='desc-slider-ss-bullet-active' data-tag={'first'} onClick={(e)=>this.clickHandler(e,0)}></span>
              </li>

              <li>
                <div>
                  <h2>{lang === 'fa' ?'اطلاعات محاسباتی':'Computational information'}</h2>
                  <p>{lang === 'fa' ?'اطلاعات کلی شامل شاخص های بازار، ده سهم اول و اطلاعیه ها و مجامع مربوط به هرسهم بخشی از اطلاعاتی ست که بورس ویو در اختیار قرار میدهد':'General information including market indices, top ten stocks, and announcements and forums are all part of the information provided by Bourse View.'}</p>
                </div>
                <span data-tag={'second'}  onClick={(e)=>this.clickHandler(e,1)}></span>
              </li>

              <li>
                <div>
                  <h2>{lang === 'fa' ?'صورت های مالی':'Financial Statements'}</h2>
                  <p>{lang === 'fa' ?'دسترسی ساده به صورت های مالی فصلی و سالانه شرکت های بورسی و زیر مجموعه ها. نحوه نمایش این صورت ها امکان مشاهده روند تغییرات فصلی و سالانه اعداد و حاشیه های صورت های مالی را تنها با چند کلیک میسر می سازد':'Easy access to seasonal and annual financial statements of stock companies and subsidiaries.'}</p>
                </div>
                <span data-tag={'third'}  onClick={(e)=>this.clickHandler(e,2)}></span>
              </li>

              <li>
                <div>
                  <h2>{lang === 'fa' ?'نمودارهای بنیادی':'Fundamental Chart'}</h2>
                  <p>{lang === 'fa' ?'اطلاعات بنیادی و نسبت های مالی شرکت ها را به راحتی و به زبان نمودار با یکدیگر مقایسه کنید. کلیه اطلاعات صورت های مالی و اقلام محاسباتی بصورت لحطه ای قابل دسترس و استفاده کاربران است':'Compare fundamentals and corporate Key Stats easily and graphically. All financial statement and accounting information is locally accessible and useable by users'}</p>
                </div>
                <span data-tag={'fourth'}  onClick={(e)=>this.clickHandler(e,3)}></span>
              </li>

              <li>
                <div>
                  <h2>{lang === 'fa' ?'فیلتر بنیادی سهام':'Screener'}</h2>
                  <p>{lang === 'fa' ?'فیلتر یا غربالگر سهام، ابزار فوق العاده قدرتمندی است که امکان پیدا کردن سهام متناسب با استراتژی شما را میسر می سازد. فقط کافی است چند دقیقه با اسکرینر بورس ویو کار کنید تا همیشه یک قدم از بازار جلوتر باشید':'Meet the stocks that meet your criteria in a second using more than 20 filters.'}</p>
                </div>
                <span data-tag={'fifth'}  onClick={(e)=>this.clickHandler(e,4)}></span>
              </li>

              <li>
                <div>
                  <h2>{lang === 'fa' ?'نسبت های مالی':'Key Stats'}</h2>
                  <p>{lang === 'fa' ?'مهمترین نسبت های مالی بر اساس نوع فعالیت شرکت ها برای هر شرکت محاسبه می شوند. محاسبه این نسبت ها از دقت فوق العاده ای برخوردار است که قبلا هیچوقت در بازار ایران پیاده سازی نشده است':'Most important ratios of each company based on its main activity with up to 20 years of history.'}</p>
                </div>
                <span data-tag={'sixth'}  onClick={(e)=>this.clickHandler(e,5)}></span>
              </li>

            </ul>
          </div>
          <div className='desc-slider-ss-svg-line-wc'>
            <Line />
          </div>
        </div>
      );
    }
  }
}



export default DescSection;